var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rules.length)?_c('box',{staticClass:"infobox rules"},[_c('div',{staticClass:"infobox-icon"},[_c('div',{staticClass:"icon"},[_c('icon',{attrs:{"name":"info"}})],1)]),_c('ul',{staticClass:"infobox-text list"},_vm._l((_vm.rules),function(rule,idx){return _c('li',{key:idx},[_vm._v(" "+_vm._s(rule.phrase)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }